import { useCallback, useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Socket from "socket";
import _ from "lodash";

import mystryWord from "assets/images/tw/mystry-word.png";
import Refree from "assets/images/tw/Referee.png";
import GuessedWord from "../components/GuessedWord";
import TWWaitingScreen from "../components/TWWaitingScreen";
import {
  divVariants,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";

const TWJudging = ({
  isJudgePlayer,
  isActivePlayer,
  word,
  roomId,
  joke,
  playerClues, screens, buzzer_sound,
  default_audio_effect
}) => {
  const active_player_word = _.get(screens, "waiting_clues.content", "You're the active player");
  const active_player_description = _.get(screens, "waiting_clues.instructions", "YOU'RE UP! HANG TIGHT WHILE PEOPLE COME UP WITH THEIR CLUES!");
  const waiting_text = _.get(screens, "judging.waiting_text", "WAITING FOR JUDGE");
  const instructions = _.get(screens, "judging.instructions", "REMOVE ANY BAD CLUES");
  const button_text = _.get(screens, "judging.button_text", "APPROVE");


  const buttonPressAction = () => {
    const data = {
      action: "update-status",
      roomId
    };
    Socket.sendMessage(data);
  };
  const RowClickAction = (playerId) => {
    if (isJudgePlayer) {
      const data = {
        action: "update-clues",
        roomId,
        playerId
      };
      Socket.sendMessage(data);
    }
  };
  const handle_submit = useCallback(
    _.debounce(() => buttonPressAction(), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );
  const handleRowClick = useCallback(
    _.debounce((playerId) => RowClickAction(playerId), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );

  useEffect(() => {
    if (isJudgePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isJudgePlayer, default_audio_effect])

  return isActivePlayer ? (
    <TWWaitingScreen
      image={mystryWord}
      guessWord={active_player_word}
      joke={joke}
      description={active_player_description}
    />
  ) : (
    <div className="judging-wrapper">
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="judging"
      >
        <div className="first">
          <GuessedWord
            image={isJudgePlayer ? Refree : mystryWord}
            word={word}
          />

          <motion.div
            variants={bounce_right_to_left_variants_without_children}
            className="players-list"
          >
            {isJudgePlayer && (
              <h3 className="Remove-txt">{instructions}</h3>
            )}
            {playerClues &&
              playerClues?.map((item, index) => {
                return (
                  <div key={index} className="player-card">
                    <div className="d-flex align-items-end">
                      <img
                        src={item.profile_image}
                        className="player-img"
                        alt=""
                      />
                      <p className="name">{item.display_name}</p>
                    </div>

                    <div
                      className="box-wrapper"
                      onClick={() => {
                        handleRowClick(item.player_id);
                      }}
                    >
                      <div className={`box ${item.valid ? "" : "disabled"}`}>
                        <h2>{item.word}</h2>
                      </div>
                      <div
                        className={`red-line ${item.valid ? "" : "not-valid"}`}
                      />
                    </div>
                  </div>
                );
              })}
          </motion.div>
        </div>
        {isJudgePlayer ? (
          <div
            className="tw-btn-wrapper"
            onClick={() => {
              handle_submit();
            }}
          >
            <div className="tw-btn">{button_text}</div>
          </div>
        ) : (
          <h2 className="waiting">{waiting_text}</h2>
        )}
      </motion.div>
    </div>
  );
};

export default TWJudging;
